import { render, staticRenderFns } from "./NormalPage.vue?vue&type=template&id=7296a6de&scoped=true&"
import script from "./NormalPage.vue?vue&type=script&lang=js&"
export * from "./NormalPage.vue?vue&type=script&lang=js&"
import style0 from "./NormalPage.vue?vue&type=style&index=0&id=7296a6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296a6de",
  null
  
)

export default component.exports